import type { MonthReport, Stock } from 'api-client'
import type { MouseHandlerDataParam } from 'recharts'

type ChartDatum = (Stock | MonthReport) & { recDateToNumber?: number | string }

export function buildRecDateToNumberIndex(list: readonly ChartDatum[]): Map<number, Stock | MonthReport> {
  return list.reduce((map, item) => {
    const xValue = item.recDateToNumber
    if (xValue != null) {
      const xNum = typeof xValue === 'string' ? Number(xValue) : xValue
      if (!Number.isNaN(xNum)) map.set(xNum, item)
    }
    return map
  }, new Map<number, Stock | MonthReport>())
}

export function resolveChartClickedData(
  list: readonly ChartDatum[],
  byRecDate: Map<number, Stock | MonthReport>,
  state: MouseHandlerDataParam | null | undefined
): Stock | MonthReport | undefined {
  if (!state || list.length === 0) return undefined

  if (typeof state.activeIndex === 'number' && state.activeIndex >= 0 && state.activeIndex < list.length) {
    return list[state.activeIndex]
  }

  if (state.activeLabel != null) {
    const labelNum = typeof state.activeLabel === 'string' ? Number(state.activeLabel) : state.activeLabel
    if (!Number.isNaN(labelNum)) return byRecDate.get(labelNum)
  }

  return undefined
}
